import { useAppSelector } from "@app/hooks";
import Input from "@components/Input";
import PageContent from "@components/PageContent";
import PageHeader from "@components/PageHeader";
import SelectWrapper from "@components/Select";
import TextArea from "@components/Textarea";
import {
  useLoadCategoryDropdownQuery,
  useLoadOneModuleMutation,
  useSaveModuleMutation,
} from "@features/admin/modules/moduleApiSlice";
import React, { useEffect, useMemo } from "react";
import {
  RiArrowLeftRightLine,
  RiDownload2Line,
  RiSwapBoxFill,
} from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import Path from "./components/PathComponent";
import moduleSlice, {
  setOneValue,
  addAccessType,
} from "@features/admin/modules/moduleSlice";
import { useDispatch } from "react-redux";
import Button from "@components/Button";
import { useInjectReducer } from "@app/store";

const ModuleAddEdit = () => {
  useInjectReducer("module", moduleSlice);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loadOne, { isLoading, isError }] = useLoadOneModuleMutation();
  const [
    saveModule,
    { isLoading: saveLoading, isError: saveError, error: saveErrorObj },
  ] = useSaveModuleMutation();
  const {
    data: categoryData,
    isLoading: catLoading,
    isError: catError,
  } = useLoadCategoryDropdownQuery();

  const { listCategory, listCategoryNormalized } = useMemo(() => {
    let listCategoryNormalized = {};
    return {
      listCategory: categoryData?.data
        ? categoryData.data.map((each) => {
            let obj = {
              label: each.module_group,
              value: each._id,
            };
            listCategoryNormalized = {
              ...listCategoryNormalized,
              [each._id]: obj,
            };
            return obj;
          })
        : [],
      listCategoryNormalized: listCategoryNormalized,
    };
  }, [catLoading]);

  const { one } = useAppSelector("module");

  useEffect(() => {
    if (id) {
      loadOne(id);
    }
  }, []);

  const handleChange = (name) => (e) => {
    dispatch(setOneValue({ key: name, value: e.target.value }));
  };

  const handleDropdown = (name) => (e) => {
    dispatch(setOneValue({ key: name, value: e.value }));
  };

  const handleSave = () => {
    saveModule(one)
      .unwrap()
      .then((res) => {
        if (res?.success) {
          navigate("/admin/module-manage");
        }
      });
  };

  return (
    <div>
      <div className='flex justify-between items-center mb-3'>
        <PageHeader
          title={id ? "Edit Module" : "Add Module"}
          isBack
          handleGoBack={() => navigate("/admin/module-manage")}
        />
        <div className='flex items-center'>
          {id && (
            <div className='flex items-center'>
              <Button
                className='btn bg-info mr-2'
                leftSection={<RiDownload2Line />}
                // onClick={() => handleExport(id)}
              >
                Download Access JSON
              </Button>
            </div>
          )}

          {id && (
            <Button
              onClick={() => navigate(`/admin/module-manage/access/${id}`)}
              leftSection={<RiArrowLeftRightLine />}
            >
              Change Accesss
            </Button>
          )}
        </div>
      </div>
      <PageContent loading={isLoading}>
        <div className='border border-gray-300 text-sm p-4'>
          <Input
            label='Module Name'
            id='module_name'
            value={one?.module_name ?? ""}
            onChange={handleChange("module_name")}
            name='module_name'
            divclassname='w-full md:w-1/2 mb-4'
            error={saveError ? saveErrorObj?.data?.errors?.module_name : null}
          />
          <TextArea
            label='Module Description'
            id='description'
            value={one?.description ?? ""}
            onChange={handleChange("description")}
            name='description'
            className='mb-4'
            error={saveError ? saveErrorObj?.data?.errors?.description : null}
          />
          <SelectWrapper
            label='Module Group'
            name='module_group'
            options={listCategory}
            value={listCategoryNormalized[one.module_group || ""]}
            onChange={handleDropdown("module_group")}
            placeholder='Select Module Group'
            divclassname='w-full md:w-1/2 mb-4'
            error={saveError ? saveErrorObj?.data?.errors?.module_group : null}
          />
          {one.path?.length > 0 &&
            one.path.map((path, pathIndex) => (
              <Path
                key={`${path._id}-${pathIndex}`}
                each={path}
                pathIndex={pathIndex}
              />
            ))}
          <div className='flex gap-2 items-center'>
            <Button loading={saveLoading} onClick={handleSave}>
              Save Changes
            </Button>
            <Button color='cyan' onClick={() => dispatch(addAccessType())}>
              Add Access Type
            </Button>
          </div>
        </div>
      </PageContent>
    </div>
  );
};

export default ModuleAddEdit;
